import { z } from 'zod'
import { ScreenSchema } from './screen'
import { IntentItemSchema } from './intent'

export const AppRegistrySchema = z
  .object({
    app: z.string().min(1),
    version: z.union([z.string().min(1), z.number().int().nonnegative()]),
    screens: z.array(ScreenSchema).min(1),
    intents: z.array(IntentItemSchema).optional(),
  })
  .superRefine((reg, ctx) => {
    const seen = new Set<string>()
    for (const [i, s] of reg.screens.entries()) {
      if (s.app !== reg.app) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `screen.app "${s.app}" must match registry.app "${reg.app}"`,
          path: ['screens', i, 'app'],
        })
      }
      if (seen.has(s.screen_id)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `duplicate screen_id "${s.screen_id}"`,
          path: ['screens', i, 'screen_id'],
        })
      }
      seen.add(s.screen_id)
    }
  })

export type AppRegistry = z.infer<typeof AppRegistrySchema>
